import { render, staticRenderFns } from "./user-filter.vue?vue&type=template&id=45535d54&"
import script from "./user-filter.vue?vue&type=script&lang=js&"
export * from "./user-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports